<template>
  <b-container>
    <b-card>
      <FormReportingChannel
        ref="form"
        :id="id"
        :request-form="requestForm"
        :title="$t('reporting_channel.screening')"
        :show-history="false"
      ></FormReportingChannel>
      <b-row class="m-0 mt-2">
        <b-col lg="12">
          <b-form @submit.prevent="saveScreening">
            <b-row class="m-0">
              <b-col md="6">
                <validation-provider
                  #default="validationContext"
                  :name="$t('reporting_channel.severity_level')"
                  rules="required"
                  class="flex-grow"
                  slim
                >
                  <b-form-group
                    :label="$t('reporting_channel.severity_level')"
                    label-for="severity_level"
                  >
                    <b-form-select
                      id="severity_level"
                      class="required-select"
                      :options="listSeverityLevels"
                      text-field="label"
                      value-field="key"
                      v-model="modelSeverityLevel"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled
                          >-- Selecione uma opção --</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback :class="[{ absolute: inline }]">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="m-0">
              <b-col>
                <b-form-group
                  :label="$t('reporting_channel.screening')"
                  label-for="treatment"
                >
                  <simple-editor v-model="textTreatment" class="mb-2" />
                </b-form-group>
              </b-col>
            </b-row>
            <div class="mt-1 mb-2">
              <div class="flex justify-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-1 mr-1 float-right"
                  :disabled="!validateForm"
                  @click="saveScreening()"
                >
                  {{ $t('save') }}
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-secondary"
                  class="mt-1 mr-1 float-right"
                  @click="$router.push('/reporting-channel/screening')"
                >
                  {{ $t('back') }}
                </b-button>
              </div>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BForm,
  BButton,
  BFormInvalidFeedback
} from 'bootstrap-vue'

// Services
import ReportingChannelFormHandlingService from '@/services/api/reporting-channel/ReportingChannelFormHandlingService'

import FormReportingChannel from '../handling/FormReportingChannel'
import SimpleEditor from '@/components/SimpleEditor.vue'

export default {
  directives: {},
  components: {
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BForm,
    BButton,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    FormReportingChannel,
    SimpleEditor
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    requestForm: null,
    modelSeverityLevel: null,
    textTreatment: '',
    listSeverityLevels: [],
    services: {
      handling: null
    }
  }),
  methods: {
    saveScreening() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      this.services.handling
        .updateScreening(this.id, {
          id: this.id,
          severity_level: this.modelSeverityLevel,
          description: this.textTreatment
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.clearFields()
            this.sucessNotify()
            this.requestForm = data
            this.$router.push('/reporting-channel/screening')
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getData(id) {
      this.$vs.loading()
      this.services.handling.read(id).then(
        data => {
          this.requestForm = data
          if (data.severity_level) {
            this.modelSeverityLevel = data.severity_level.key || null
          }
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    clearFields() {
      this.modelSeverityLevel = null
      this.textTreatment = ''
    },
    sucessNotify() {
      this.$vs.notify({
        title: this.$t('messages.success_title'),
        text: this.$t('messages.success'),
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
    }
  },
  computed: {
    validateForm() {
      return this.modelSeverityLevel !== null
    }
  },
  mounted() {
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {
    this.services.handling = ReportingChannelFormHandlingService.build(this.$vs)

    this.services.handling.getSeverityLevelList().then(
      data => {
        this.listSeverityLevels = data
      },
      error => {
        this.$vs.loading.close()
      }
    )
  }
}
</script>
